import styled from "styled-components"

export const Url = styled.div`
  min-width: 35rem;
  padding-right: 2rem;
`
